import script from "./UiTemplate.js?vue&type=script&lang=js"
export * from "./UiTemplate.js?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__